module.exports = __webpack_public_path__ + "static/media/logo_cloned_plate.844d20b2.png";